import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { COLORS, BRAND } from '@/lib/brand';
import { ClipboardList, LogOut, User, Package, ClipboardCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

const InventaristaLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: COLORS.background.DEFAULT }}>
      {/* Header con fondo naranja TUPU Stock */}
      <header 
        className="sticky top-0 z-50 shadow-md"
        style={{ backgroundColor: COLORS.primary.DEFAULT }}
        data-testid="inventarista-header"
      >
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div 
                className="h-10 w-10 rounded-lg flex items-center justify-center shadow-sm"
                style={{ backgroundColor: '#FFFFFF' }}
              >
                <ClipboardList className="w-6 h-6" style={{ color: COLORS.primary.DEFAULT }} />
              </div>
              <div>
                <h1 className="text-lg font-bold text-white">{BRAND.name}</h1>
                <p className="text-xs text-white/70">Inventarista</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4">
              {user?.lugares_recuento?.length > 0 && (
                <Link
                  to={location.pathname.startsWith('/inventarista/recuentos') ? '/inventarista' : '/inventarista/recuentos'}
                  className="flex items-center gap-1 text-sm font-medium text-white bg-white/15 hover:bg-white/25 px-3 py-1.5 rounded-lg"
                  data-testid="inventarista-recuentos-link"
                >
                  <ClipboardCheck className="w-4 h-4" />
                  {location.pathname.startsWith('/inventarista/recuentos') ? 'Inventario' : 'Recuentos'}
                </Link>
              )}
              <div className="flex items-center gap-2 text-sm text-white/80">
                <User className="w-4 h-4" />
                <span>{user?.name || user?.username}</span>
              </div>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={handleLogout}
                className="text-white/90 hover:text-white hover:bg-white/10"
                data-testid="inventarista-logout-button"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Salir
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto" data-testid="inventarista-main-content">
        {children}
      </main>
    </div>
  );
};

export default InventaristaLayout;
